import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getWarehouseStageUsers = (warehouseId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/' +
      warehouseId +
      '/stage-user', // for android use
    headers: getHeaders(),
  });
};

export const createWarehouseStageUsers = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/' +
      warehouseId +
      '/stage-user', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putWarehouseStageUsers = (warehouseId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/' +
      warehouseId +
      '/stage-user', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};